module.exports = __webpack_public_path__ + "assets/img/course_program.38a131f8.png";